import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { HsmKeyTypeMappingObj } from '../services/getActiveKeyTypeMappingsList'

export interface KeyMappingsListState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  data: HsmKeyTypeMappingObj | null
}

const initialState: KeyMappingsListState = {
  isLoading: false,
  error: null,
  httpStatus: 0,
  data: null
}

const keyTypeMappingsListSlice = createSlice({
  name: 'keyTypeMappingsList',
  initialState,
  reducers: {
    keyTypeMappingsListLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        data: null
      }
    },
    keyTypeMappingsListUpdateAction: (state, action: PayloadAction<{ data: HsmKeyTypeMappingObj, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        data: action.payload.data
      }
    },
    keyTypeMappingsListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        data: null
      }
    }
  }
})

export const {
  keyTypeMappingsListLoadingAction,
  keyTypeMappingsListUpdateAction,
  keyTypeMappingsListErrorAction
} = keyTypeMappingsListSlice.actions

export default keyTypeMappingsListSlice.reducer
